// Get the redirectUri for the current hostname setup
const redirectUri = () => {
	if (["www.trackside-hospitality.visacashapprb.com", "trackside-hospitality.visacashapprb.com", "trackside-hospitality-prod-0c7cb6c31a9c.herokuapp.com"].includes(window.location.hostname)) {
		// Production redirect
		return "https://trackside-hospitality.visacashapprb.com"
	} else if (
		["www.trackside-hospitality-stage.visacashapprb.com", "trackside-hospitality-stage.visacashapprb.com", "trackside-hospitality-staging-c237f56ce689.herokuapp.com"].includes(
			window.location.hostname,
		)
	) {
		// Staging redirect
		return "https://trackside-hospitality-stage.visacashapprb.com"
	} else {
		// Prod redirect
		return "https://trackside-hospitality.visacashapprb.com"
	}
}

// MSAL client-side package config
export const msalConfig = {
	auth: {
		clientId: "88561b78-9005-40ef-8014-61aab4a82eee",
		// clientId: "4537f712-7a8c-4a37-ad22-8435a73082ab",
		redirectUri: redirectUri(),
		authority: "https://login.microsoftonline.com/713ff3df-8381-485b-bb86-d30e44360da9",
		// authority: "https://login.microsoftonline.com/edac428d-4f0d-4954-9713-75609e9bbe45",
		knownAuthorities: ["login.microsoftonline.com"],
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: true,
	},
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints
export const loginRequest = {
	scopes: ["User.Read"],
}
